import React, {useEffect, useState} from 'react';
import {
    HeaderContainer,
    HeaderTitle,
    HeaderWrapper,
    StyledFilterButton,
    StyledHeaderActions
} from "./DocumentsDigitizationHeader.styled";
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';

import SearchInput from "../../../../../components/common/SearchInput";
import DocumentsDigitizationFilters from "../DocumentsDigitizationFilters";
import {LocalDocumentsSearchQueryParams} from "../../../../../models/local-documents.models";
import {useTranslation} from "react-i18next";

interface DocumentsDigitizationHeaderProps {
    filters: LocalDocumentsSearchQueryParams;
    onFiltersChange: (filters: LocalDocumentsSearchQueryParams) => void;
    onSearchChange: (value: string) => void;
    onExport: () => Promise<void>;
    isExportDisabled: boolean;
}

const DocumentsDigitizationHeaderStyled = ({ filters, onFiltersChange, onSearchChange, onExport, isExportDisabled }: DocumentsDigitizationHeaderProps) => {
    const {t} = useTranslation();

    const [searchTerm, setSearchTerm] = useState('');
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            onSearchChange(searchTerm);
        }, 300);

        return () => clearTimeout(timer); // cleanup with every change
    }, [searchTerm]);

    const handleSearchChange = (value: string) => {
        setSearchTerm(value);
    };

    const handleFiltersChange = (newFilters: LocalDocumentsSearchQueryParams) => {
        onFiltersChange(newFilters);
    };

    const handleToggleFilter = (e: React.MouseEvent<HTMLButtonElement>) => {
        setVisible(!visible);
    };

    return (
        <HeaderWrapper>
            <HeaderContainer>
                <HeaderTitle>{t('documentsDigitization.title')}</HeaderTitle>

                <StyledHeaderActions>
                    <SearchInput
                        onChange={handleSearchChange}
                        value={searchTerm}
                        placeholder={t('documentsDigitization.searchPlaceholder') as string}
                        ariaLabel={t('documentsDigitization.searchPlaceholder') as string}
                    />

                    <StyledFilterButton variant="outlined" onClick={handleToggleFilter} startIcon={<FilterAltOutlinedIcon />}>
                        {t('documentsDigitization.filterButton')}
                    </StyledFilterButton>

                    <StyledFilterButton variant="contained" color="primary" onClick={onExport} disabled={isExportDisabled} startIcon={<FileDownloadOutlinedIcon />}>
                        {t('documentsDigitization.export.button')}
                    </StyledFilterButton>
                </StyledHeaderActions>
            </HeaderContainer>

            <DocumentsDigitizationFilters visible={visible} filters={filters} onFiltersChange={handleFiltersChange} />
        </HeaderWrapper>
    );
};

export default DocumentsDigitizationHeaderStyled;